import { useEffect,useState } from 'react'
import { all_routes } from '../../router/all_routes'
import { DatePicker } from 'antd';
import CommonSelect from '../../../core/common/commonSelect';
import { Employee } from '../../../types/dataModel';
import { isNotEmpty, isValidEmail, isValidPhoneNumber, toDateFromEpoch } from '../../../common/Utils';
import dayjs from 'dayjs';
import {API, GENDER} from '../../../common/Constants'
import useFetch from '../../../hooks/useFetch';
import PreLoader from '../../../core/common/preLoader';
import DepartmentDropDown from './departmentDropDown';
import { getAPIHeaders } from '../../../common/Utils';
import ProfilePic from '../../../core/common/profilePic';
import CommonSelectV2 from '../../../core/common/commonSelectV2';

type PasswordField = "password" | "confirmPassword";

interface Props {
    employee?: Employee
    onSuccess: ()=> void
    designations: any[]
    roleOpts: any[]
    employeeRoles?: any[]
}

const ModifyEmployee = ({employee, designations, roleOpts, employeeRoles, onSuccess}:Props) => {
    const [formEmployee, setFromEmployee] = useState<Employee>()
    const [msgBox, setMsgBox] = useState<any>({
      msg: "",
      error: false
    });
    const {isLoading, error, data, status, callFetch } = useFetch();
    const [defaultDept, setDefualtDept] = useState<any>()
    const [defaultDesig, setDefualtDesig] = useState<any>()
    const [defaultGender, setDefualtGender] = useState<any>()
    const [defaultRole, setDefultRoles] = useState<any[]>()

    useEffect(()=>{
      if(!employeeRoles?.length){
        setDefultRoles(undefined)
      }
      setFromEmployee({
        ...formEmployee,
        roles: employeeRoles
      })
    },[employeeRoles])

    useEffect(()=>{
        setFromEmployee({...employee,
          roles: formEmployee?.roles
        })
        setDefualtDept({
            label: employee?.departmentName, 
            value: employee?.departmentId
        })
        setDefualtDesig({
          label: employee?.designationName, 
          value: employee?.designationId
        })
        setDefualtGender({
          ...GENDER.find((ele) => ele.value === employee?.gender)
        })

    },[employee])


    const reset = () => {
      resetMsgBox()
    }

    const resetMsgBox = () => {
      setMsgBox({
        msg: "",
        error: false
      })
    }

    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });

    const togglePasswordVisibility = (field: PasswordField) => {
        setPasswordVisibility((prevState) => ({
        ...prevState,
        [field]: !prevState[field],
        }));
    };

    useEffect(() => {
          if(data && status && status < 299){
            setMsgBox({msg: "Updated successfully", error: false})
            onSuccess()
          }
    }, [status]);
    
    
    useEffect(() => {
        if(error){
          if(error.response?.data){
            setMsgBox({msg: error.response?.data, error: true})
          } else{
            setMsgBox({msg: 'Something went wrong please try again later.', error: true})
          }
        }
    }, [error]);
    
    const handleBasicInfoSubmit = (event:any) => {
      event.preventDefault()
      setMsgBox({msg:"",error: false})
      if (!isNotEmpty(formEmployee?.firstName )) {
        setMsgBox({ msg: "First Name is required.", error: true });
        return;
      }
    
      if (!isNotEmpty(formEmployee?.lastName)) {
        setMsgBox({ msg: "Last Name is required.", error: true });
        return;
      }
    
      if (!isValidEmail(formEmployee?.email)) {
        setMsgBox({ msg: "Email is required.", error: true });
        return;
      }
    
      if (!formEmployee?.dob) {
        setMsgBox({ msg: "Date of Birth is required.", error: true });
        return;
      }
    
      if (!isNotEmpty(formEmployee?.gender)) {
        setMsgBox({ msg: "Gender is required.", error: true });
        return;
      }

      if (!isValidPhoneNumber(formEmployee?.phoneNumber)) {
        setMsgBox({ msg: "Provide valid 10 digit phone number.", error: true });
        return;
      }

      callFetch(`${API.HRM_PROFILE}/${formEmployee?.profileId}`,
            'PUT',
            getAPIHeaders(),
            null,
            {
                firstName: formEmployee?.firstName,
                lastName: formEmployee?.lastName,
                phoneNumber: formEmployee?.phoneNumber,
                email: formEmployee?.email,
                dob: formEmployee?.dob,
                gender: formEmployee?.gender,
            }
        );
    }

    const handleOrgSubmit = (event:any) => {
      event.preventDefault()
      setMsgBox({msg:"",error: false})
      callFetch(API.EMPLOYEE,
            'PUT',
            getAPIHeaders(),
            null,
            {
                id: formEmployee?.employeeId,
                departmentId: formEmployee?.departmentId,
                designationId: formEmployee?.designationId,
            }
        );
    }

    const handleSubmitRoles = (event:any) =>{
      event.preventDefault()
      setMsgBox({msg:"",error: false})
      if(formEmployee?.accountId){
        callFetch(API.USER_ROLES.replace('{id}',`${formEmployee?.accountId}`),
          'POST',
          getAPIHeaders(),
          null,
          [...formEmployee?.roles?.map((role:any)=>{
            return role.value
          }) || []]
        );
      }
    }

    const handlePasswordSubmit = (event:any) => {
      event.preventDefault()
      if(formEmployee?.password !== formEmployee?.confirmPassword){
        setMsgBox({msg:"Password mismatch! Password and confirm password must match",error: true})
      } else {
        setMsgBox({msg:"",error: false})
        callFetch(API.PWD_RESET,
              'POST',
              getAPIHeaders(),
              null,
              {
                accountId: formEmployee?.accountId,
                newPassword: formEmployee?.password,
              }
          );
      }
    }


    const renderModifyBasicForm =() => {
      return (
        <div
        className="tab-pane fade show active"
        id="basic-info2"
        role="tabpanel"
        aria-labelledby="info-tab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-12">
              <ProfilePic id={formEmployee?.profileId}/>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  First Name <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formEmployee?.firstName}
                  onChange={(e)=>{setFromEmployee({
                    ...formEmployee,
                    firstName: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Last Name <span className="text-danger"> *</span></label>
                <input
                  type="email"
                  className="form-control"
                  defaultValue={formEmployee?.lastName}
                  onChange={(e)=>{setFromEmployee({
                    ...formEmployee,
                    lastName: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Date of Birth <span className="text-danger"> *</span>
                </label>
                <div className="input-icon-end position-relative">
                  <DatePicker
                    className="form-control datetimepicker"
                    format={{
                      format: "DD-MM-YYYY",
                      type: "mask",
                    }}
                    getPopupContainer={getModalContainer}
                    placeholder="DD-MM-YYYY"
                    value={dayjs(toDateFromEpoch(formEmployee?.dob))}
                    onChange={(dt)=>{
                      setFromEmployee({
                        ...formEmployee,
                        dob: dt?.toDate()?.getTime()/1000
                      })
                    }}
                  />
                  <span className="input-icon-addon">
                    <i className="ti ti-calendar text-gray-7" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Gender <span className="text-danger"> *</span>
                </label>
                  <CommonSelect
                    className='select'
                    options={GENDER}
                    defaultValue={defaultGender}
                    onChange={(value) => {
                      setFromEmployee({
                        ...formEmployee,
                        gender: value
                      })
                    }}
                  />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Email <span className="text-danger"> *</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  defaultValue={formEmployee?.email}
                  onChange={(e)=>{setFromEmployee({
                    ...formEmployee,
                    email: e?.target?.value
                  })}}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Phone Number <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formEmployee?.phoneNumber}
                  onChange={(e)=>{setFromEmployee({
                    ...formEmployee,
                    phoneNumber: parseInt(e?.target?.value)
                  })}}
                    onKeyPress={(e) => {
                      // Allow only numeric input
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ justifyContent: "space-between"}}>
          {renderMsgBox()}
          <div>
            <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
              onClick={reset}
            >
              Cancel
            </button>
            <button type="button" 
              className="btn btn-primary"
              onClick={handleBasicInfoSubmit}>
              Save{" "}
            </button>
          </div>
        </div>
      </div>
      )
    }

    const renderMsgBox = () => {
      return (
        <div>
        { msgBox?.msg  
            ?
            msgBox?.error
            ?
              <>
                <i className="ti ti-alert-triangle text-danger" />  
                <span className='text-danger'> {msgBox?.msg} </span> 
              </> 
            :
              <>
                <i className="ti ti-thumb-up text-success" />  
                <span className='text-success'> {msgBox?.msg} </span> 
              </> 
            : <></>
        }
      </div>
      )
    }

    const renderModifyOrgForm = () => {
      return (
        <div
        className="tab-pane fade show"
        id="orginfo2"
        role="tabpanel"
        aria-labelledby="org-infotab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Employee ID <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formEmployee?.employeeId}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Department <span className="text-danger"> *</span></label>
                <DepartmentDropDown
                  defaultDepartment={defaultDept}
                  handleChange={(value:any)=>{
                    setFromEmployee({
                      ...formEmployee,
                      departmentId: parseInt(value)
                    })
                  }}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Designation <span className="text-danger"> *</span></label>
                <CommonSelect
                  className='select'
                  options={designations}
                  defaultValue={defaultDesig}
                  onChange={(value:any)=>{
                    setFromEmployee({
                      ...formEmployee,
                      designationId: parseInt(value)
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ justifyContent: "space-between"}}> 
          {renderMsgBox()}
          <div>
            <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
              onClick={reset}
            >
              Cancel
            </button>
            <button type="button" 
              className="btn btn-primary"
              onClick={handleOrgSubmit}>
              Save{" "}
            </button>
          </div>
        </div>
      </div>
      )
    }


    const renderAuthForm = () => {
      return (
        <div
        className="tab-pane fade show"
        id="auth-info2"
        role="tabpanel"
        aria-labelledby="auth-infotab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">
                  Username <span className="text-danger"> *</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={formEmployee?.username}
                  disabled
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3 ">
                <label className="form-label">
                  Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={
                      passwordVisibility.password
                        ? "text"
                        : "password"
                    }
                    className="pass-input form-control"
                    value={formEmployee?.password? formEmployee?.password : ""}
                    onChange={(e)=>{setFromEmployee({
                      ...formEmployee,
                      password: e?.target?.value
                    })}}
                  />
                  <span
                    className={`ti toggle-passwords ${passwordVisibility.password
                      ? "ti-eye"
                      : "ti-eye-off"
                      }`}
                    onClick={() =>
                      togglePasswordVisibility("password")
                    }
                  ></span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3 ">
                <label className="form-label">
                  Confirm Password <span className="text-danger"> *</span>
                </label>
                <div className="pass-group">
                  <input
                    type={
                      passwordVisibility.confirmPassword
                        ? "text"
                        : "password"
                    }
                    className="pass-input form-control"
                    value={formEmployee?.confirmPassword ? formEmployee?.confirmPassword : ""}
                    onChange={(e)=>{setFromEmployee({
                      ...formEmployee,
                      confirmPassword: e?.target?.value
                    })}}
                  />
                  <span
                    className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                      ? "ti-eye"
                      : "ti-eye-off"
                      }`}
                    onClick={() =>
                      togglePasswordVisibility("confirmPassword")
                    }
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ justifyContent: "space-between"}}>
        {renderMsgBox()}
        <div>
          <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
              onClick={reset}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary"
              onClick={handlePasswordSubmit}>
              Save{" "}
            </button>
        </div>

        </div>
      </div> 
      )
    }

    const renderAccessForm = () => {
      return (
        <div
        className="tab-pane fade show"
        id="access-info2"
        role="tabpanel"
        aria-labelledby="access-infotab2"
        tabIndex={0}
      >
        <div className="modal-body pb-0 ">
          <div className="row">
            <div className="col-md-8">
              <div className="mb-3">
                <label className="form-label">
                  Roles <span className="text-danger"> *</span>
                </label>
                <CommonSelectV2 
                  isMulti 
                  options={roleOpts}
                  defaultValues={defaultRole}
                  values={formEmployee?.roles?.length ? formEmployee?.roles : null}
                  onChange={(value: any[]) => {
                      let newRoles: any[] = value?.map((v: string) => {
                        return roleOpts?.find((role: any) => role?.value === v)
                      })
                      setFromEmployee({
                        ...formEmployee,
                        roles: [...newRoles]
                      })
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ justifyContent: "space-between"}}>
        {renderMsgBox()}
        <div>
          <button
              type="button"
              className="btn btn-outline-light border me-2"
              data-bs-dismiss="modal"
              onClick={reset}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary"
              onClick={handleSubmitRoles}>
              Save{" "}
            </button>
        </div>

        </div>
      </div> 
      )
    }

    return (
    <div className="modal fade" id="edit_employee"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
       <PreLoader showLoader={isLoading} />
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <h4 className="modal-title me-2">Edit Employee</h4>
              <span>Employee ID : {formEmployee?.employeeId}</span>
            </div>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={reset}
            >
              <i className="ti ti-x" />
            </button>
          </div>


          <form action={all_routes.employeeList}>
            <div className="contact-grids-tab">
              <ul className="nav nav-underline" id="myTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="info-tab2"
                    data-bs-toggle="tab"
                    data-bs-target="#basic-info2"
                    type="button"
                    role="tab"
                    aria-selected="true"
                    onClick={resetMsgBox}
                  >
                    Basic Information
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="org-infotab2"
                        data-bs-toggle="tab"
                        data-bs-target="#orginfo2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Organizational Info
                      </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="auth-infotab2"
                        data-bs-toggle="tab"
                        data-bs-target="#auth-info2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Account Info
                      </button>
                </li>
                <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="access-infotab2"
                        data-bs-toggle="tab"
                        data-bs-target="#access-info2"
                        type="button"
                        role="tab"
                        aria-selected="false"
                        onClick={resetMsgBox}
                      >
                        Access Info
                      </button>
                </li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent2">  
              {renderModifyBasicForm()}
              {renderModifyOrgForm()}
              {renderAuthForm()}
              {renderAccessForm()}
            </div>
          </form>


        </div>
      </div>
    </div>
    )
}

export default ModifyEmployee